module.exports = {"Type":"Regex","Fields":[{"label":"Name of the variable","name":"name","serializeTo":"node"},{"label":"Regex Expression","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"black","BackgroundColor":"gray","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Regex.json
// module id = 701
// module chunks = 0